<!--  -->
<template>
  <div class="footer">
    <!-- <div>
      <a href="">牵星出海</a> | <a href="">招标搜索</a> |
      <a href="">商务合作</a> | <a href="">关于我们</a>
    </div>-->
    <div>
      友情链接：
      <a href="http://www.cipg.org.cn/" target="_blank">中国外文出版发行事业局</a>|
      <a href="http://www.ctis-cn.com/" target="_blank">中外翻译</a>|
      <a href="http://www.inewyee.com" target="_blank">译鱼</a>|
      <a href="http://kaifan.cipgtrans.com/dis/#/index" target="_blank">开翻</a>
    </div>
    <div>
      <p style="display:inline-block;margin-right:10px;">Copyright ©2017 北京中外翻译咨询有限公司 版权所有</p>
      <p style="display:inline-block;">联系方式：010-68326084 转 6027</p>
    </div>
    <div style="margin:0 auto;">
      <a
        target="_blank"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202009654"
        style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
      >
        <img src="../assets/ga.png" style="display:inline-block;" />
        <p
          style="display:inline-block;height:20px;line-height:20px;margin: 0px 0px 0px 5px;"
        >京公网安备 11010202009654号</p>
      </a>
      <a href="https://beian.miit.gov.cn" target="_blank">京ICP备16008517号-3</a>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'about',
  components: {},
  data() {
    //这里存放数据
    return {}
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.footer {
  background: #2e3d4b;
  color: #fff;
  width: 100%;
  font-size: 14px;
  padding: 20px 0 20px 0;
  div {
    margin-bottom: 10px;
  }
  a {
    color: #fff;
    margin: 10px 40px;
    line-height: 30px;
  }
}
</style>
